import { render, staticRenderFns } from "./OctFormRow.vue?vue&type=template&id=23dc2bd6&scoped=true&"
import script from "./OctFormRow.vue?vue&type=script&lang=js&"
export * from "./OctFormRow.vue?vue&type=script&lang=js&"
import style0 from "./OctFormRow.vue?vue&type=style&index=0&id=23dc2bd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dc2bd6",
  null
  
)

export default component.exports